import { c as _c } from "react/compiler-runtime";
import FilterButton from '@/components/modules/ListOptionsBar/FilterButton';
import FilterModal from '@/components/modules/ListOptionsBar/FilterModal';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { ExperienceCheckBox } from '@winelidays/wld-tsx-2/fields';
import { ModalContent } from '@winelidays/wld-tsx-2/modules';
import { isEqual } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useState } from 'react';
import useReviewsExperiencesFilter from '../../context/useReviewsExperienceFilter';
const ExperienceFilter = (t0) => {
    const $ = _c(46);
    const { formId, disabled } = t0;
    const translate = useTranslate();
    const { selectedExperienceIds, experienceOptions, setExperienceOptions } = useReviewsExperiencesFilter();
    const hasSelection = selectedExperienceIds.length > 0;
    let t1;
    if ($[0] !== translate) {
        t1 = translate("messages.experience");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const filterName = t1;
    let t2;
    if ($[2] !== experienceOptions || $[3] !== selectedExperienceIds[0] || $[4] !== selectedExperienceIds.length) {
        t2 = selectedExperienceIds.length === 1 ?
            <span className="truncate">
      {experienceOptions[selectedExperienceIds[0]].bookable.name}
    </span> :
            "";
        $[2] = experienceOptions;
        $[3] = selectedExperienceIds[0];
        $[4] = selectedExperienceIds.length;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    let t3;
    if ($[6] !== selectedExperienceIds.length || $[7] !== t2 || $[8] !== translate) {
        t3 = translate("review.experience_filter.label", { count: selectedExperienceIds.length, experienceName: t2 });
        $[6] = selectedExperienceIds.length;
        $[7] = t2;
        $[8] = translate;
        $[9] = t3;
    }
    else {
        t3 = $[9];
    }
    const btnLabel = t3;
    const [isOpen, setIsOpen] = useState(false);
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = () => {
            setIsOpen(true);
        };
        $[10] = t4;
    }
    else {
        t4 = $[10];
    }
    const handleOpen = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = () => {
            setIsOpen(false);
        };
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    const handleClose = t5;
    const [localValues, setLocalValues] = useState(experienceOptions);
    let t6;
    let t7;
    if ($[12] !== experienceOptions) {
        t6 = () => {
            setLocalValues(experienceOptions);
        };
        t7 = [experienceOptions];
        $[12] = experienceOptions;
        $[13] = t6;
        $[14] = t7;
    }
    else {
        t6 = $[13];
        t7 = $[14];
    }
    useEffect(t6, t7);
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (e) => {
            setLocalValues((c) => {
                const newOptions = { ...c };
                newOptions[parseInt(e.target.name, 10)].checked = e.target.checked;
                return (newOptions);
            });
        };
        $[15] = t8;
    }
    else {
        t8 = $[15];
    }
    const handleCheckBoxChange = t8;
    const localSelectedExperienceIds = Object.values(localValues).filter(_temp).map(_temp2);
    const hasOneChecked = localSelectedExperienceIds.length > 0;
    const hasDiffWithActive = !isEqual(localSelectedExperienceIds.sort(), selectedExperienceIds.sort());
    let t9;
    if ($[16] !== formId || $[17] !== localValues || $[18] !== translate) {
        let t10;
        if ($[20] !== formId || $[21] !== translate) {
            t10 = (t11) => {
                const [key, t12] = t11;
                const { bookable, checked: checked_0 } = t12;
                return (<ExperienceCheckBox formId={formId} key={key} bookable={bookable} checked={checked_0} onChange={handleCheckBoxChange} translate={translate}/>);
            };
            $[20] = formId;
            $[21] = translate;
            $[22] = t10;
        }
        else {
            t10 = $[22];
        }
        t9 = Object.entries(localValues).map(t10);
        $[16] = formId;
        $[17] = localValues;
        $[18] = translate;
        $[19] = t9;
    }
    else {
        t9 = $[19];
    }
    const modalContent = t9;
    let t10;
    if ($[23] !== localValues || $[24] !== setExperienceOptions) {
        t10 = () => {
            setExperienceOptions(localValues);
            handleClose();
        };
        $[23] = localValues;
        $[24] = setExperienceOptions;
        $[25] = t10;
    }
    else {
        t10 = $[25];
    }
    const handleApply = t10;
    let t11;
    if ($[26] !== setExperienceOptions) {
        t11 = () => {
            setExperienceOptions(_temp3);
            handleClose();
        };
        $[26] = setExperienceOptions;
        $[27] = t11;
    }
    else {
        t11 = $[27];
    }
    const handleReset = t11;
    let t12;
    if ($[28] !== modalContent) {
        t12 = <ModalContent>{modalContent}</ModalContent>;
        $[28] = modalContent;
        $[29] = t12;
    }
    else {
        t12 = $[29];
    }
    let t13;
    if ($[30] !== filterName || $[31] !== handleApply || $[32] !== handleReset || $[33] !== hasDiffWithActive || $[34] !== hasOneChecked || $[35] !== isOpen || $[36] !== t12) {
        t13 = <FilterModal filterName={filterName} isOpen={isOpen} onClose={handleClose} onApply={handleApply} hasDiffWithActive={hasDiffWithActive} hasDiffWithInitial={hasOneChecked} onReset={handleReset}>{t12}
    </FilterModal>;
        $[30] = filterName;
        $[31] = handleApply;
        $[32] = handleReset;
        $[33] = hasDiffWithActive;
        $[34] = hasOneChecked;
        $[35] = isOpen;
        $[36] = t12;
        $[37] = t13;
    }
    else {
        t13 = $[37];
    }
    let t14;
    if ($[38] !== btnLabel || $[39] !== disabled || $[40] !== handleReset || $[41] !== hasSelection) {
        t14 = <FilterButton title={btnLabel} onClick={handleOpen} isActive={hasSelection} onReset={handleReset} disabled={disabled}>

      {btnLabel}
    </FilterButton>;
        $[38] = btnLabel;
        $[39] = disabled;
        $[40] = handleReset;
        $[41] = hasSelection;
        $[42] = t14;
    }
    else {
        t14 = $[42];
    }
    let t15;
    if ($[43] !== t13 || $[44] !== t14) {
        t15 = <>{t13}{t14}</>;
        $[43] = t13;
        $[44] = t14;
        $[45] = t15;
    }
    else {
        t15 = $[45];
    }
    return t15;
};
export default ExperienceFilter;
function _temp(t0) { const { checked } = t0; return !!checked; }
function _temp2(t0) { const { bookable: t1 } = t0; const { identifier } = t1; return identifier; }
function _temp3(c_0) { const n = { ...c_0 }; for (const key_0 in n) {
    n[key_0].checked = false;
} return n; }
